<aside class="sidebar">
  <button
    type="button"
    class="sidebar__toggle"
    (click)="toggle()"
    [attr.aria-expanded]="open()"
  >
    <span class="sidebar__toggle-label">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
        <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
      Категорії
    </span>
    <span class="sidebar__toggle-value">{{ selectedName() }}</span>
    <svg class="sidebar__chevron" [class.sidebar__chevron--open]="open()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  </button>

  <h2 class="sidebar__title">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
      <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
    Категорії
  </h2>

  <div class="sidebar__panel" [class.sidebar__panel--open]="open()">
    @if (store.loading()) {
      <ul class="sidebar__list">
        @for (s of [1,2,3,4,5,6,7,8]; track s) {
          <li class="sidebar__skeleton"></li>
        }
      </ul>
    }

    @if (store.error()) {
      <p class="sidebar__error">Не вдалося завантажити категорії</p>
    }

    @if (!store.loading() && !store.error()) {
      <ul class="sidebar__list">
        <li>
          <a
            class="sidebar__item"
            routerLink="/"
            [queryParams]="{}"
            [class.sidebar__item--active]="onCatalog() && selectedSlug() === null"
          >
            <span class="sidebar__item-icon sidebar__item-icon--all">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
              </svg>
            </span>
            Всі товари
          </a>
        </li>
        @for (cat of store.categories(); track cat.id) {
          <li>
            <a
              class="sidebar__item"
              routerLink="/"
              [queryParams]="{ category: cat.slug }"
              [class.sidebar__item--active]="selectedSlug() === cat.slug"
            >
              @if (cat.iconUrl) {
                <img class="sidebar__item-icon" [src]="cat.iconUrl" [alt]="cat.name" width="16" height="16" />
              } @else {
                <span class="sidebar__item-icon sidebar__item-icon--placeholder"></span>
              }
              {{ cat.name }}
            </a>
          </li>
        }
        @if (store.categories().length === 0) {
          <li class="sidebar__empty">Категорії ще не додані</li>
        }
      </ul>
    }
  </div>
</aside>
